interface IntroData{
    title: string;
    description: string;
    questionsTitle: string;
    questions: string[];
}

type IntroBlockProps = IntroData & {
  onQuestionClick?: (question: string) => void;
};

const IntroBlock = ({ onQuestionClick, title, description, questionsTitle, questions }: IntroBlockProps) => {
//   const exampleQuestions = [
//     "Какие темы мне лучше повторить перед интервью?",
//     "На что вы смотрите в senior .NET разработчике?",
//     "Что для вас важно в архитектурном мышлении?",
//   ];

  return (
    <div className="relative shrink-0 w-full" data-name="intro-block">
      <div className="content-stretch flex flex-col gap-[15px] px-[20px] py-[20px] relative w-full">
        <div className="flex flex-col gap-[10px]">
          <h2 className="font-['Manrope:Bold',sans-serif] font-bold leading-[normal] text-[#0f172a] text-[16px]">
            {title}
          </h2>
          <p className="font-['Manrope:Regular',sans-serif] font-normal leading-[1.5] text-[#334155] text-[14px]">
            {description}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-['Manrope:Medium',sans-serif] font-medium leading-[normal] text-[#334155] text-[12px]">
            {questionsTitle}
          </p>
          {questions.map((question, index) => (
            <button
              key={index}
              onClick={() => onQuestionClick?.(question)}
              className="content-stretch cursor-pointer flex items-center justify-start px-[12px] py-[8px] relative rounded-[8px] bg-[#f8fafc] border border-[#ddd] hover:bg-[#e9ebef] active:bg-[#ddd] transition-colors text-left"
            >
              <p className="font-['Manrope:Regular',sans-serif] font-normal leading-[1.4] text-[#0f172a] text-[13px]">
                {question}
              </p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default IntroBlock;
export type { IntroData };